import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=23d63430&scoped=true&"
import script from "./PaymentPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPopup.vue?vue&type=style&index=0&id=23d63430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d63430",
  null
  
)

export default component.exports